import { render, staticRenderFns } from "./LoginsList.vue?vue&type=template&id=de445f7a&"
import script from "./LoginsList.vue?vue&type=script&lang=ts&"
export * from "./LoginsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports